@file:OptIn(InternalResourceApi::class)

package soundgame.app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/soundgame.app.shared.generated.resources/"

@delegate:ResourceContentHash(-934_673_115)
internal val Res.font.audiowide_regular: FontResource by lazy {
      FontResource("font:audiowide_regular", setOf(
        ResourceItem(setOf(), "${MD}font/audiowide_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_038_061_591)
internal val Res.font.courier_prime_regular: FontResource by lazy {
      FontResource("font:courier_prime_regular", setOf(
        ResourceItem(setOf(), "${MD}font/courier_prime_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_169_605_698)
internal val Res.font.finger_paint_regular: FontResource by lazy {
      FontResource("font:finger_paint_regular", setOf(
        ResourceItem(setOf(), "${MD}font/finger_paint_regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("audiowide_regular", Res.font.audiowide_regular)
  map.put("courier_prime_regular", Res.font.courier_prime_regular)
  map.put("finger_paint_regular", Res.font.finger_paint_regular)
}
